<template>
    <v-container>
        <v-data-table
            :headers="headers"
            :items="currentMonsters"
            :items-per-page="-1"
            dense
            class="elevation-1"
            hide-default-footer
        >
            <template v-slot:[`item.name`]="{ item }">
                <v-btn class="mx-2" icon small color="red" @click="removeMonster(item.keyId)">
                    <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
                <router-link :to="{ name: 'readMonster', params: { id: item.keyId } }" :title="item.name">
                    {{ item.name }}
                </router-link>
            </template>
        </v-data-table>
        <v-row class="mt-3" v-if="hasEditPermission">
            <v-col cols="12" sm="9">
                <monster-picker rows="2" label="Add New Monster..." @selected="monsterSelected" />
            </v-col>
            <v-col cols="12" sm="1">
                <v-btn title="Add Monster" color="success" @click="addMonster" :disabled="!canAddMonster">
                    <v-icon>mdi-plus</v-icon>
                </v-btn>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import api from '@/api'
import MonsterPicker from '@/components/MonsterSelector.vue'
import permissionsSet from '@/components/permissions'
export default {
    name: 'PlotMonsterManager',
    components: {
        'monster-picker': MonsterPicker,
    },
    props: {
        id: {
            type: [Number, String],
            required: true,
            validator: value => {
                return !!value
            },
        },
        permissions: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            isLoading: false,
            newMonsterKeyId: null,
            currentMonsters: [],
            monsters: [],
            headers: [
                {
                    text: 'Name',
                    align: 'start',
                    value: 'name',
                },
            ],
        }
    },
    computed: {
        canAddMonster() {
            return !!this.newMonsterKeyId && this.hasEditPermission
        },
        hasEditPermission() {
            return this.permissions.includes(permissionsSet.Edit)
        },
    },
    mounted() {
        this.getCurrentMonsters()
    },
    methods: {
        getCurrentMonsters() {
            this.isLoading = true
            api.get(`plots/${this.id}/monsters`)
                .then(res => {
                    this.currentMonsters = res
                })
                .finally(() => {
                    this.isLoading = false
                })
        },
        monsterSelected(val) {
            if (!val || !val.keyId) return
            this.newMonsterKeyId = val.keyId
        },
        addMonster() {
            this.isLoading = true
            api.post(`plots/${this.id}/monsters/${this.newMonsterKeyId}`)
                .then(() => {
                    this.newMonsterKeyId = null
                    this.getCurrentMonsters()
                })
                .finally(() => {
                    this.isLoading = false
                })
        },
        removeMonster(monsterKeyId) {
            this.$confirm({
                title: 'Confirm',
                body: 'Are you sure you want to remove this monster?',
            }).then(confirmResult => {
                if (confirmResult) {
                    this.isLoading = true
                    api.delete(`plots/${this.id}/monsters/${monsterKeyId}`)
                        .then(() => {
                            this.getCurrentMonsters()
                        })
                        .finally(() => {
                            this.isLoading = false
                        })
                }
            })
        },
    },
}
</script>
